import React, { ReactElement } from "react";

import { PageHeader } from "@buildresonance/resonance-lib-layout-components";
import { Container } from "@mui/material";

import { MyDemandHqsCard } from "./MyDemandHqsCard";

import { DOCS_DOMAIN_NAME } from "@lib/common/domainNames";
import { openInNewTabUsingWindow } from "@util/openInANewTabUsingWindow";

const MyDemandHqsParent = (): ReactElement => {
    return (
        <Container>
            <PageHeader
                title="My DemandHqs"
                infoProps={{
                    label: "What is a DemandHq?",
                    iconButtonProps: {
                        onClick: () =>
                            openInNewTabUsingWindow(
                                `https://${DOCS_DOMAIN_NAME}/concepts/demand-hqs/demand-hq-concepts`,
                            ),
                    },
                }}
            />
            <MyDemandHqsCard />
        </Container>
    );
};

export { MyDemandHqsParent };
